module.exports = "<div class=\"center\">\n    <mat-progress-spinner mode=\"indeterminate\"></mat-progress-spinner>\n</div>"